/* eslint-disable react-hooks/exhaustive-deps */
import { Container, Grid } from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import EquiposClub from '../components/clubes/EquiposClub';
import {
  BoxDatosApp,
  BoxDatosItemApp,
  BoxTitleApp,
  LoadingApp,
  PageHeaderBox,
  PaperApp,
  TypographyApp,
} from '../components/custom/CustomComponents';
import { Context } from '../service/Context';
import { capitalizar, ordenarPorCategoria } from '../utils/UtilesComun';

/**
 * Pagina de un club.
 */
const Club = () => {
  const navigate = useNavigate();
  const { obtenerDatosClub, obtenerEquiposClub } = useContext(Context);

  const { routeIdClub } = useParams();

  const [datosClub, setDatosClub] = useState(undefined);
  const [equiposClub, setEquiposClub] = useState(undefined);
  const [loading, setLoading] = useState(true);

  // Cargar datos desde la API
  useEffect(() => {
    async function cargarDatos() {
      const [datosClubRes, equiposClubRes] = await Promise.all([
        obtenerDatosClub(routeIdClub),
        obtenerEquiposClub(routeIdClub),
      ]);
      const ordenados = ordenarPorCategoria(equiposClubRes);

      if (ordenados.length > 0 && ordenados[0]?.idEquipo) {
        navigate(`/equipo/${ordenados[0].idEquipo}`, { replace: true });
        return;
      }

      setDatosClub(datosClubRes);
      setEquiposClub(equiposClubRes);
      setLoading(false);
    }
    cargarDatos();
  }, [routeIdClub]);

  if (loading) {
    return <LoadingApp />;
  }

  if (!datosClub || !equiposClub) {
    return null;
  }

  return (
    <Container maxWidth={false} sx={{ mt: 4, mb: 4 }}>
      <PageHeaderBox>{capitalizar(datosClub.nombre)}</PageHeaderBox>
      <Grid container spacing={2} sx={{ p: 2 }}>
        <Grid item md={0.5} />
        <Grid item xs={12} md={4}>
          <BoxDatosApp>
            <BoxTitleApp>Información del Club</BoxTitleApp>
            <BoxDatosItemApp>
              <TypographyApp fontSize="0.9rem" sx={{ fontWeight: 'bold' }}>
                Nombre:
              </TypographyApp>
              <TypographyApp fontSize="0.9rem">{capitalizar(datosClub.nombre)}</TypographyApp>
            </BoxDatosItemApp>
            <BoxDatosItemApp>
              <TypographyApp fontSize="0.9rem" sx={{ fontWeight: 'bold' }}>
                Localidad:
              </TypographyApp>
              <TypographyApp fontSize="0.9rem">{capitalizar(datosClub.localidad)}</TypographyApp>
            </BoxDatosItemApp>
            <BoxDatosItemApp>
              <TypographyApp fontSize="0.9rem" sx={{ fontWeight: 'bold' }}>
                Provincia:
              </TypographyApp>
              <TypographyApp fontSize="0.9rem">{capitalizar(datosClub.provincia)}</TypographyApp>
            </BoxDatosItemApp>
          </BoxDatosApp>
        </Grid>
        <Grid item xs={12} md={5}>
          <PaperApp>
            <BoxTitleApp>Equipos</BoxTitleApp>
            <EquiposClub equiposClub={equiposClub} />
          </PaperApp>
        </Grid>
      </Grid>
    </Container>
  );
};

export default Club;
